<div id="forms-full-size-image-dialog" data-cy="forms-dialog-image-container">
  <img [src]="imagePath" data-cy="forms-dialog-image" />
</div>
